'use client'

import Script from 'next/script'
import { useTermlyConsent } from './useTermlyConsent'

interface ConsentBasedGoogleAnalyticsProps {
  measurementId: string
  debug?: boolean
}

export function ConsentBasedGoogleAnalytics({
  measurementId,
  debug = false
}: ConsentBasedGoogleAnalyticsProps) {
  const hasConsent = useTermlyConsent(debug)

  // Only render GA scripts if consent is given
  if (!hasConsent) {
    return null
  }

  return (
    <>
      <Script
        id="google-analytics-script"
        data-testid="google-analytics-script"
        data-category="analytics"
        src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
        strategy="afterInteractive"
      />
      <Script
        id="google-analytics-config"
        data-testid="google-analytics-config"
        data-category="analytics"
        strategy="afterInteractive"
      >
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}', {
            send_page_view: true
          });
        `}
      </Script>
    </>
  )
}

export default ConsentBasedGoogleAnalytics
